import React from 'react';
import PropTypes from 'prop-types';
import Autocomplete from '@material-ui/lab/Autocomplete';
import TextFieldStandardized from 'Components/ComponentLibrary/Components/Uncategorized/TextField';
import { buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';

const useStyles = buildUseStyles('SearchableSelect', () => ({
  root: {
    '& .MuiAutocomplete-popupIndicator': {
      color: 'inherit',
    },
  },
  textField: {
    marginTop: 0,
  },
}));

function SearchableSelect({
  options, onChange, label, test, value, disabled, clearable,
}) {
  const classes = useStyles();

  return (
    <Autocomplete
      disabled={disabled}
      test={test}
      className={classes.root}
      renderInput={params => (
        <TextFieldStandardized className={classes.textField} {...params} label={label} margin="normal" />
      )}
      getOptionLabel={option => option.name}
      options={options}
      onChange={(e, opt) => {
        e.stopPropagation();
        if (opt === null) {
          return onChange(opt);
        }
        return onChange(opt?.value);
      }}
      disableClearable={!clearable}
      value={options.find(option => option.value === value)}
    />
  );
}

SearchableSelect.defaultProps = {
  clearable: false,
};

SearchableSelect.propTypes = {
  options: PropTypes.array.isRequired,
  onChange: PropTypes.func.isRequired,
  label: PropTypes.string.isRequired,
  test: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  disabled: PropTypes.bool.isRequired,
  clearable: PropTypes.bool,
};

export { SearchableSelect };
